import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { func, string, bool } from "prop-types";
import { Field, Form, Formik } from "formik";
import TextField from "pages/_components/fields/TextField";
import Button from "pages/_components/Button";
import Credential from "pages/_components/fields/credentials/Credential";
import { actions as accountsActions } from "reducers/accounts";
import { ResponsiveHeader } from "pages/_components/header";
import { resizableRoute } from "pages/_components/Resizable";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";
import Container from "pages/_components/Container";
import Col from "react-bootstrap/lib/Col";
import List from "pages/_components/List";
import Image from "pages/_components/Image";

import { isIOS, isMobile } from "react-device-detect";

const SetCbuAliasForm = ({ idAccount, cbu, closeSidebar, setNewAlias, oldAlias, toggleSidebar, isDesktop }) => {
    const dispatch = useDispatch();
    const [alias, setAlias] = useState(oldAlias);
    const IDFORM = "accounts.cbu";
    const schema = Yup.object().shape({
        newAlias: Yup.string()
            .matches(/^[A-Za-z\d\-.]{6,20}$/g, i18n.get(`${IDFORM}.newAlias.field.error.incorrectFormat`))
            .required(i18n.get(`${IDFORM}.newAlias.field.error.empty`))
            // eslint-disable-next-line no-shadow
            .when("password", (newAlias, schema) =>
                schema.test({
                    // eslint-disable-next-line no-shadow
                    test: (newAlias) => newAlias !== oldAlias,
                    message: i18n.get(`${IDFORM}.newAlias.field.error.same`),
                }),
            ),
        password: Yup.string().required(i18n.get("form.enter.password")),
    });
    useEffect(() => {
        setAlias(oldAlias);
    }, [oldAlias]);

    const handleSubmit = (values, formikBag) => {
        dispatch(
            accountsActions.changeCbuAlias(idAccount, cbu, values.newAlias, values.password, formikBag, toggleSidebar),
        );
        formikBag.resetForm();
        closeSidebar();
        setNewAlias(values.newAlias);
    };

    const handleAliasChange = (values) => {
        setNewAlias(values.newAlias);
        setAlias(values.newAlias);
    };

    return (
        <>
            {isMobile || isIOS ? <ResponsiveHeader id="accounts.details.information.alias.setAlias" /> : null}
            <Container className="container accounts__edit-alias">
                <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3} className="text-left">
                    {isDesktop && (
                        <div className="mb-4 f-weight-b">
                            <I18n id="accounts.details.information.alias.setAlias" component="h2" />
                        </div>
                    )}
                    <p className="accounts__edit-alias-title">{i18n.get("accounts.details.information.alias.info")}</p>
                    <Formik
                        enableReinitialize
                        validateOnChange={false}
                        initialValues={{ newAlias: alias, password: "" }}
                        onSubmit={(values, formikBag) => handleSubmit(values, formikBag)}
                        validationSchema={schema}>
                        {({ isSubmitting }) => (
                            <Form className="above-the-fold accounts__edit-alias-form">
                                <Field
                                    autoFocus
                                    component={TextField}
                                    idForm={IDFORM}
                                    name="newAlias"
                                    type="text"
                                    value={alias}
                                    handleOnChange={handleAliasChange}
                                    hidePlaceholder
                                />
                                <List className="accounts__edit-alias-helper">
                                    <div className="helper-step">
                                        <Image src="images/stepCircle.svg" />
                                        <I18n id="accounts.cbu.newAlias.helper.step1" component="span" />
                                    </div>
                                    <div className="helper-step">
                                        <Image src="images/stepCircle.svg" />
                                        <I18n id="accounts.cbu.newAlias.helper.step2" component="span" />
                                    </div>
                                    <div className="helper-step">
                                        <Image src="images/stepCircle.svg" />
                                        <I18n id="accounts.cbu.newAlias.helper.step3" component="span" />
                                    </div>
                                    <div className="helper-step">
                                        <Image src="images/stepCircle.svg" />
                                        <I18n id="accounts.cbu.newAlias.helper.step4" component="span" />
                                    </div>
                                    <div className="helper-step">
                                        <Image src="images/stepCircle.svg" />
                                        <I18n id="accounts.cbu.newAlias.helper.step5" component="span" />
                                    </div>
                                </List>
                                <Field
                                    idForm="login.step2"
                                    name="password"
                                    copyEnabled={false}
                                    component={Credential}
                                />
                                <Button
                                    type="submit"
                                    bsStyle="primary"
                                    label="global.send"
                                    loading={isSubmitting}
                                    block
                                />
                            </Form>
                        )}
                    </Formik>
                </Col>
            </Container>
        </>
    );
};

SetCbuAliasForm.propTypes = {
    cbu: string.isRequired,
    closeSidebar: func.isRequired,
    idAccount: string.isRequired,
    setNewAlias: func.isRequired,
    oldAlias: string.isRequired,
    toggleSidebar: func.isRequired,
    isDesktop: bool.isRequired,
};

export default resizableRoute(SetCbuAliasForm);
